"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubePlaylist1Schema = void 0;
exports.YoutubePlaylist1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/youtube-playlist/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "YoutubePlaylist1",
    "description": "Embed a youtube playlist",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:youtube-playlist:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "playlistId": {
                    "type": "string",
                    "description": "The playlist from which the video should be played ('list=' parameter)"
                }
            },
            "required": [
                "playlistId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy95b3V0dWJlLXBsYXlsaXN0LzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsc0JBQXNCLEdBQUc7SUFDcEMsS0FBSyxFQUFFLHFGQUFxRjtJQUM1RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxrQkFBa0I7SUFDM0IsYUFBYSxFQUFFLDBCQUEwQjtJQUN6QyxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sNkNBQTZDO2FBQzlDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osWUFBWSxFQUFFO29CQUNaLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsd0VBQXdFO2lCQUN4RjthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFlBQVk7YUFDYjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9